import '../Authenticate.css';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import Loader from '../../../../common/loader/Loader';
import Turnstile from '../../../../common/turnstile/Turnstile';

export default function Signup() {

    const {
        isLoggedIn,
        handleSignup,
        authLoading,
        username, setUsername,
        email, setEmail,
        password, setPassword,
        showPassword, setShowPassword,
        emailError,
        usernameError,
        passwordError,
        captchaError,
        turnstileRef,
    } = useAuth();

    const navigate = useNavigate();

    const emailErrorComponent = emailError ? <p><i className="fa-solid fa-circle-info"></i> {emailError}</p> : '';
    const usernameErrorComponent = usernameError ? <p><i className="fa-solid fa-circle-info"></i> {usernameError}</p> : '';
    const passwordErrorComponent = passwordError ? <p><i className="fa-solid fa-circle-info"></i> {passwordError}</p> : '';
    const captchaErrorComponent = captchaError ? <p><i className="fa-solid fa-circle-info"></i> {captchaError}</p> : '';

    useEffect(() => {
        if (!authLoading && isLoggedIn) {
            navigate('/');
        }
    }, [authLoading, isLoggedIn, navigate]);

    if (authLoading || isLoggedIn) {
        return (
            <main><Loader /></main>
        )
    }

    return (
        <main className='authenticate-main'>
            <h2>Sign up</h2>
            <form onSubmit={handleSignup} className='authenticate-form'>
                <label className='authenticate-form-field'>
                    <span>Email</span>
                    <br></br>
                    <input className='authenticate-form-input' type='text' value={email} onChange={(e) => setEmail(e.target.value)} required />
                    {emailErrorComponent}
                </label>
                <label className='authenticate-form-field'>
                    <span>Username</span>
                    <br></br>
                    <input className='authenticate-form-input' type='text' value={username} onChange={(e) => setUsername(e.target.value)} required />
                    {usernameErrorComponent}
                </label>
                <label className='authenticate-form-field'>
                    <span>Password</span>
                    <br></br>
                    <div className='authenticate-form-input-container'>
                        <input className='authenticate-form-input password' type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} required />
                        <button className='authenticate-show-password' type='button' onClick={() => setShowPassword(prev => !prev)}>
                            {password.length > 0 ?
                            <i className={showPassword ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"}></i> :
                            <></>
                            }
                        </button>
                    </div>
                    {passwordErrorComponent}
                </label>
                <div className='authenticate-form-field'>
                    <Turnstile ref={turnstileRef} action='signup' />
                    {captchaErrorComponent}
                </div>
                <button className="btn-login" type='submit'>Sign up</button>
            </form>
            <p className='authenticate-toggle-format'>
                <span>Already have an account? </span>
                <Link className='underline' to={'/user/login'}>Log in</Link>
            </p>
        </main>
    );
}